import "./App.css"
import { AppRouters } from "./routes/Routes"
import { FC } from "react"

import { initializeApp } from 'firebase/app'
import { getRemoteConfig } from "firebase/remote-config"
import firebaseConfig from "./config/firebaseConfig"
import CookieConsent from "@components/CookieConsent"
const app = initializeApp(firebaseConfig)
export const remoteConfig = getRemoteConfig(app)
remoteConfig.settings = {
  fetchTimeoutMillis: 6000, minimumFetchIntervalMillis: 6000
}
remoteConfig.defaultConfig = {
  isNativeSharedDialog: false
}

const App: FC = () => {


  return (<>
    <AppRouters />
    {/* <CookieConsent/> */}
  </>
  )

}
export default App
